import Rails from '@rails/ujs';
import { Turbo } from '@hotwired/turbo-rails';
import { Application as Stimulus } from 'stimulus';
import 'iframe-resizer';
import '../application/vendor/jquery.watermark';
import '../application/v2.scss';
import '../application/public.scss';
import '../styleguide/styleguide';

import FlashMessage from '../application/app/flash_message';
import ToggleShown from '../application/app/toggle_shown';
import CopyToClipboard from '../application/app/copy_to_clipboard';
import ToggleOpen from '../application/app/toggle_open';
import SidePanel from '../application/app/sidepanel';
import SidePanelForm from '../application/app/sidepanel_form';
import DarkMode from '../application/app/dark_mode';
import MobileDropdown from '../application/app/mobile_dropdown';
import SubmitForm from '../application/app/submit_form';
import UserTimeZone from '../application/app/user_time_zone';
import ToggleCollapse from '../application/app/toggle_collapse';
import ItemsMasks from '../application/app/items_masks';
import GroupSwitchOnOff from '../application/app/group_switch_on_off';
import SyncEditor from '../application/app/sync_editor';
import WebShare from '../application/app/web_share';
import EventPrint from '../application/app/event_print';
import EventWebsiteDropdown from '../application/app/event_website_dropdown';
import PageTheme from '../application/app/page_theme';
import RegistrationPanel from '../application/app/registration_panel';
import PasswordVisibilityController from '../controllers/password_visibility_controller';
import AnalyticsEventController from '../controllers/analytics_event_controller';
import LoginPanelErrors from '../application/app/login_panel_errors';

window.Turbo = Turbo;

/*
  Stimulus on the Event Website (Trello #1022).

  The Log In panel is the SAME view the primary Bobcat login renders, and its
  password field has always carried the password-visibility controller. Only
  application-v2 and admin ever started Stimulus, though, so on an Event Website
  the controller never connected: the eye did nothing when clicked, and the
  button never got the inline `top` that places it inside the input -- the CSS
  positions it absolutely and leaves the vertical offset to connect(). Both
  reported differences are that one omission.

  Registered by name rather than by require.context over the whole controllers
  directory: the public bundle is served to every visitor of every Event
  Website, and it should carry what these pages actually use rather than
  everything the signed-in application happens to have.
*/
const stimulusApp = Stimulus.start();
stimulusApp.register('password-visibility', PasswordVisibilityController);
stimulusApp.register('analytics-event', AnalyticsEventController);

document.addEventListener('turbo:load', () => {
  DarkMode.start();
  FlashMessage.start();
  ToggleShown.start();
  CopyToClipboard.start();
  ToggleOpen.start();
  ToggleCollapse.start();
  SidePanel.start();
  SidePanelForm.start();
  MobileDropdown.start();
  SubmitForm.start();
  UserTimeZone.start();
  ItemsMasks.start();
  GroupSwitchOnOff.start();
  SyncEditor.start();
  WebShare.start();
  EventPrint.start();
  EventWebsiteDropdown.start();
  PageTheme.start();
  RegistrationPanel.start();
  LoginPanelErrors.start();
});

Rails.start();
